import FinanceIcon from './FinanceIcon';
import FinanceSubdivisions, { subdivisionTotal } from './FinanceSubdivisions';

const movementLabels = { entrada: 'Entrada', saida: 'Saída' };

export default function AdminFinanceForm({ form, statusLabels, isSaving, onSubmit, onCancel, onSubdivisionsChange, updateField, addExtraField, updateExtraField, removeExtraField }) {
  return (
        <section className="edit-panel" aria-label={form.id ? 'Editar lançamento financeiro' : 'Cadastrar lançamento financeiro'}>
          <div className="edit-panel-header">
            <div>
              <span className="eyebrow">{form.id ? 'Edição' : 'Novo lançamento'}</span>
              <h2>{form.id ? 'Atualizar movimentação' : 'Registrar entrada ou saída'}</h2>
            </div>
            <button type="button" className="secondary-button icon-only" onClick={onCancel} aria-label="Voltar para lançamentos" title="Voltar para lançamentos">
              <FinanceIcon name="back" />
            </button>
          </div>

          <form className="quote-form" onSubmit={onSubmit}>
            <div className="form-grid">
              <fieldset className="movement-selector" translate="no">
                <legend>Tipo</legend>
                <div className="movement-options">
                  {Object.entries(movementLabels).map(([value, label]) => (
                    <label key={value} className={`movement-option ${value} ${form.movementType === value ? 'selected' : ''}`}>
                      <input type="radio" name="movementType" value={value} checked={form.movementType === value} onChange={updateField} required />
                      <FinanceIcon name={value === 'entrada' ? 'income' : 'outcome'} />
                      <span>{label}</span>
                    </label>
                  ))}
                </div>
              </fieldset>

              <label>
                Frequência do lançamento
                <select name="recurrenceType" value={form.recurrenceType} onChange={updateField} required>
                  <option value="avulso">Avulso</option>
                  <option value="mensal">Mensal/recorrente</option>
                </select>
                <small className="helper-text">{form.recurrenceType === 'mensal' ? 'Repete automaticamente nos meses seguintes. Alterações de valor e subdivisões valem deste mês em diante, inclusive para os próximos já gerados; meses anteriores são preservados. Para interromper, altere para Avulso e salve.' : 'Não gera repetições. Ao desativar uma recorrência, os meses até o atual são preservados e as próximas repetições são removidas.'}</small>
              </label>

              <label>
                Status
                <select name="status" value={form.status} onChange={updateField} required>
                  {Object.entries(statusLabels).map(([value, label]) => (
                    <option value={value} key={value}>
                      {label}
                    </option>
                  ))}
                </select>
                <small className="helper-text">{form.status === 'pago' ? (form.movementType === 'entrada' ? 'Valor já recebido.' : 'Valor já pago.') : form.status === 'pendente' ? 'Aguardando pagamento ou recebimento.' : form.status === 'em_andamento' ? 'Pagamento ou recebimento em processamento.' : 'Movimentação cancelada.'}</small>
              </label>

              <label>
                Descrição do lançamento
                <input name="description" value={form.description} onChange={updateField} placeholder="Ex.: Ensaio pago, edição, transporte..." required />
              </label>

              <label>
                Categoria
                <input name="category" value={form.category} onChange={updateField} placeholder="Cliente, equipamento, deslocamento..." />
              </label>

              <label>
                {form.subdivisions.length ? 'Valor total (calculado)' : 'Valor'}
                <input
                  name="amount"
                  type="text"
                  inputMode="decimal"
                  value={form.subdivisions.length ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(subdivisionTotal(form.subdivisions)) : form.amount}
                  readOnly={form.subdivisions.length > 0}
                  onChange={updateField}
                  placeholder="R$ 0,00"
                  required
                />
              </label>

              <label>
                Data do lançamento
                <input name="transactionDate" type="date" value={form.transactionDate} onChange={updateField} required />
              </label>

              <label>
                Vencimento ou previsão
                <input name="dueDate" type="date" value={form.dueDate} onChange={updateField} />
              </label>
            </div>

            <FinanceSubdivisions items={form.subdivisions} onChange={onSubdivisionsChange} />

            <label>
              Observações
              <textarea
                name="notes"
                value={form.notes}
                onChange={updateField}
                rows="4"
                placeholder="Detalhes para lembrar depois ou apresentar ao contador."
              />
            </label>

            <div className="extra-fields-panel">
              <div className="extra-fields-header">
                <div>
                  <span className="eyebrow">Opcional</span>
                  <h3>Campos adicionais para a planilha</h3>
                </div>
                <button type="button" className="secondary-button compact-button" onClick={addExtraField}>
                  Adicionar campo
                </button>
              </div>

              {form.extraFields.length === 0 && (
                <p className="helper-text">Use quando precisar incluir uma informação específica no Excel, sem alterar o sistema.</p>
              )}

              {form.extraFields.map((field, index) => (
                <div className="extra-field-row" key={field.id}>
                  <label>
                    Campo
                    <input
                      value={field.label}
                      onChange={(event) => updateExtraField(index, 'label', event.target.value)}
                      placeholder="Ex.: Forma de pagamento"
                    />
                  </label>

                  <label>
                    Valor
                    <input
                      value={field.value}
                      onChange={(event) => updateExtraField(index, 'value', event.target.value)}
                      placeholder="Ex.: Pix"
                    />
                  </label>

                  <button type="button" className="danger-button icon-only" onClick={() => removeExtraField(index)} aria-label={`Remover campo adicional ${index + 1}`} title="Remover campo">
                    <FinanceIcon name="trash" />
                  </button>
                </div>
              ))}
            </div>

            <div className="form-actions">
              <button type="button" className="secondary-button" onClick={onCancel}>
                Cancelar
              </button>
              <button type="submit" disabled={isSaving}>
                {isSaving ? 'Salvando...' : form.id ? 'Salvar alterações' : 'Cadastrar lançamento'}
              </button>
            </div>
          </form>
        </section>
  );
}
